module.exports = __webpack_public_path__ + "static/media/playlist-info-home-icon.ed795648.svg";